import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=28c29434&scoped=true"
import script from "./sendEmail.vue?vue&type=script&lang=js"
export * from "./sendEmail.vue?vue&type=script&lang=js"
import style0 from "./sendEmail.vue?vue&type=style&index=0&id=28c29434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c29434",
  null
  
)

export default component.exports